var universalTransitionEndName = function () {
  if (typeof document === 'undefined') return undefined;
  var el = document.createElement('foo');
  var listenerVariants = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
  };

  for (var t in listenerVariants) {
    if (el.style[t] !== undefined) {
      return listenerVariants[t];
    }
  }

  return undefined;
}();
/**
 * Function which attaches `eventListener` to the correct browser-dependent version of the transition end event on `element`.
 * The value returned is `true` if the browser supports any version of the transition end callback.
 * @param {*} element element to attach the callback to
 * @param {*} eventListener event listener to attach to the element
 * @returns `true` if the browser supports any transition end callback version, `false` otherwise
 */


export var addUniversalTransitionEnd = function addUniversalTransitionEnd(element, eventListener) {
  if (universalTransitionEndName === undefined) return false;
  element.addEventListener(universalTransitionEndName, eventListener, false);
  return true;
};
/**
 * Function which removes `eventListener` from the correct browser-dependent version of the transition end event on `element`.
 * The value returned is `true` if the browser supports any version of the transition end callback.
 * @param {*} element element to remove the callback from
 * @param {*} eventListener event listener to remove from the element, must be **same instance** as the one attached
 * @returns `true` if the browser supports any transition end callback version, `false` otherwise
 */

export var removeUniversalTransitionEnd = function removeUniversalTransitionEnd(element, eventListener) {
  if (universalTransitionEndName === undefined) return false;
  element.removeEventListener(universalTransitionEndName, eventListener, false);
  return true;
};